export default __webpack_public_path__ + "static/media/payment ui-whitebg.2d707634.png";